/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import type { StepProps } from '@src/components/setup.steps/models'
import styles from '@src/components/setup.steps/setup.steps.styl'
import Button from '@src/components/common/button'

export const AlertsConfigFooter: React.FC<StepProps> = (props: StepProps) => {
  const { steps, stepId, switchStep } = props

  function previousStep() {
    if (steps[stepId - 1]) {
      switchStep(stepId - 1)
    }
  }

  function nextStep() {
    if (steps[stepId + 1]) {
      switchStep(stepId + 1)
    }
  }

  return (
    <div className={styles.buttonWrapper}>
      <Button
        id="BackButton"
        title={'BACK'}
        className={styles.backButton}
        onClick={previousStep}
      />
      <Button
        id="NextButton"
        title={'NEXT'}
        className={styles.nextButton}
        onClick={nextStep}
      />
    </div>
  )
}
